const layoutVariants = {
    betCardWrapper: {
        root: {
            position: "relative",
            display: "flex",
            flexDirection: "column",
            marginTop: 0,
            marginBottom: "12px",
            borderRadius: "16px",
            fontFamily: "Open Sans, sans-serif",
            backgroundColor: "$gray800",
            color: "$white",
            fontWeight: 400,
            fontSize: "10px",
            lineHeight: "9px",
            overflow: "hidden",
        },
    },
    betCard: {
        root: {
            position: "relative",
            display: "flex",
            flexDirection: "column",
            padding: "20px",
        },
        everyChild: {
            zIndex: 1,
        }
    },
    borderedCard: {
        root: {
            borderRadius: "$s1",
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "$gray700",
        }
    },
    eventCard: {
        $extendFromVariant: ["betCard", "borderedCard"],
        root: {
            marginTop: 0,
            marginBottom: "$s2",
            paddingTop: "14px",
            paddingRight: "$s2",
            paddingBottom: "14px",
            paddingLeft: "$s2",
            backgroundColor: "transparent",
        }
    },
    replayCard: {
        $extendFromVariant: ["eventCard"],
        root: {
            paddingTop: "10px",
            paddingRight: "12px",
            paddingBottom: "10px",
            paddingLeft: "12px",
        }
    },
    selectionCard: {
        root: {
            display: "flex",
            flexDirection: "column",
            flex: "1 1 auto",
        }
    },
    selectionCardLast: {
        $extendFromVariant: "selectionCard",
        lastChild: {
            margin: 0,
        }
    },
    bonus: {
        root: {
            display: "flex",
            flexDirection: "column",
        },
        firstChild: {
            marginBottom: "11px",
        },
        lastChild: {
            marginBottom: "$s2",
        }
    },
    ghostLeg: {
        root: {
            display: "flex",
            flexDirection: "column",
            marginBottom: "10px"
        },
    },
    earlyExit: {
        root: {
            display: "flex",
            flexDirection: "column",
            fontSize: "10px",
            marginBottom: "10px",
            gap: "8px",
        },
    },
    earlyExitBonus: {
        root: {
            display: "flex",
            flexDirection: "column",
            fontSize: "10px",
        },
    },
    myBetsContent: {
        root: {
            flex: "1 1 auto",
            marginLeft: [0, "$s3", "$s4"],
            marginRight: [0, "$s3", "$s4"],
        }
    }
};
export { layoutVariants };
//# sourceMappingURL=layout.js.map